import React, { lazy, useEffect, useState } from "react";
import PageLayout from "./PageLayout";
import {
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from "react-router";
import { Navigate } from "react-router";
import PageNotFound from "./PageNotFound";
import { PageStatusById } from "./ErrorBoundary";
import { useClientBlogs } from "./useClientBlogs";
import { useClientEvaluations } from "./useClientEvaluations";
import { useClientVacancy } from "./useClientVacancy";
import { useClientTravel } from "./useClientTravel";
import { useClientInsideTravel } from "./useClientInsideTravel";
import { useClientInsuranceAndMore } from "./useClientInsuranceAndMore";
import { useClientStudent } from "./useClientStudent";
import { useClientSaerto } from "./useClientSaerto";
import { useClientAboutUs } from "./useClientAboutUs";
import { useClientOffices } from "./useClientOffices";
import { useClientChatBot } from "./useClientChatBot";
import { useClientOffers } from "./useClientOffers";
// import { useClientOurTeam } from "./useClientOurTeam";
import { useClientMoreAboutInsurance } from "./useClientMoreAboutInsurance";
import { useClientLegalInformation } from "./useClientLegalInformation";
import { useClientFinancialInformation } from "./useClientFinancialInformation";
import { useClientCorpInsurance } from "./useClientCorpInsurance";
import { useClientUno } from "./useClientUno";
import { useClientCar } from "./useClientCar";
import { useClientCarAuto } from "./useClientCarAuto";
import { useClientUnoActive } from "./useClientUnoActive";
import { useClientUnoSelect } from "./useClientUnoSelect";
import { useClientUnoComfort } from "./useClientUnoComfort";

import { useDispatch, useSelector } from "react-redux";
import actions from "src/store/common/actions";

// import actionsMain from "src/store/mainPage/actions";
import { routesSubroutes } from "../Breadcrumb";
// import { useClientGephaProposal } from "./useClientGephaProposal";
import NoSms from "../noSms";
import Tootsie from "../tootsie";
import ErrorMessagePage from "src/components/offlineFolder/errorMessagePage";
import ErrorMessage from "src/components/offlineFolder/ErrorMessage";
import PrivacyPolicies from "./PrivacyPolicies";
import OpenFileWithOid from "./OpenFileWithOid";
import PrivacyStatement from "./PrivacyStatement";
import RequestCall from "../requestCall";
import PayRedirect from "../payRedirect";

export const HOME_PAGE_URL = "home/";
export const CLIENT_BLOGS = "blogs";
export const CLIENT_OFFERS = "offers";
export const CLIENT_BLOGS_DETAILS = "blog-details";
export const CLIENT_BLOGS_EVALUATIONS = "evaluations";
export const CLIENT_VACANCY = "vacancy";
export const CLIENT_TRAVEL = "travel";
export const TEMPORARY_PROFILE_DOCTOR = "profile-doctor";
export const TEMPORARY_APPEALS = "appeals";
export const TEMPORARY_REIMB = "compensations";
export const CLIENT_INSURANCE_AND_MORE = "insurance-and-more";
export const CLIENT_STUDENT = "student";
export const CLIENT_SAERTO = "ind-health-insurance";
export const CLIENT_ABOUTUS = "about-us";
export const CLIENT_OFFICES = "offices";
export const CLIENT_CHATBOT = "chat-bot";
// export const CLIENT_OURTEAM = 'our-team';
export const CLIENT_MORE_ABOUT_INSURANCE = "more-about-insurance";
export const CLIENT_LEGAL_INFO = "legal-info";
export const CLIENT_FINANCIAL_INFO = "financial-info";
export const CLIENT_CORP_INSURANCE = "corp-insurance";
export const CLIENT_PAYMENT_RESULT = "payment-result";
export const CLIENT_GEPHA_PROPOSAL = "gepha-proposal";
export const NO_SMS = "no-sms";
export const TOOTSIE = "tootsie-event";
export const PRIVACY_POLICY = "privacy-policy";
export const PRIVACY_STATEMENT = "privacy-statement";
export const CLIENT_INSIDE_TRAVEL = "visitors-insurance";
// export const CLIENT_OFFERS = "offers";
export const CLIENT_UNO = "uno";
export const CLIENT_CAR = "car";
export const CLIENT_UNO_ACTIVE = "uno-active";
export const CLIENT_UNO_SELECT = "uno-select";
export const CLIENT_UNO_COMFORT = "uno-comfort";
export const CLIENT_AUTO_CAR = "auto-car";
export const REQUEST_CALL = "call";
export const PAY_REDIRECT = "pay";
const errorInModules = true;
const MainPage = lazy(() => import("src/containers/MainPage/index.js"));
const BlogDetails = lazy(() => import("src/containers/BlogDetails/index.js"));
const PaymentResult = lazy(() =>
  import("src/containers/PaymentResult/index.js")
);

export const PageLoadFailedComponent = () => (
  <PageStatusById id="common.PageLoadFailed" />
);
export const PageCrashedComponent = () => (
  <PageStatusById id="common.PageCrashed" />
);

const travelRoute = "/Purchase/TravelPolicyPurchase";

const Layout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const lang = useSelector((state) => state.common.lang);

  const ClientBLogs = useClientBlogs();
  const ClientEvaluations = useClientEvaluations();
  const ClientVacancy = useClientVacancy();
  const ClientInsideTravel = useClientInsideTravel();
  const ClientOffers = useClientOffers();
  const ClientTravel = useClientTravel();
  const ClientInsuranceAndMore = useClientInsuranceAndMore();
  const ClientStudent = useClientStudent();
  const ClientSaerto = useClientSaerto();
  const ClientAboutUs = useClientAboutUs();
  const ClientOffices = useClientOffices();
  const ClientChatBot = useClientChatBot();
  // // const ClientOurTeam = useClientOurTeam();
  const ClientMoreAboutInsurance = useClientMoreAboutInsurance();
  const ClientLegalInformation = useClientLegalInformation();
  const ClientFinancialInformation = useClientFinancialInformation();
  const ClientCorpInsurance = useClientCorpInsurance();
  const ClientUno = useClientUno();
  const ClientUnoActive = useClientUnoActive();
  const ClientUnoSelect = useClientUnoSelect();
  const ClientCar = useClientCar();
  const ClientCarAuto = useClientCarAuto();
  const ClientUnoComfort = useClientUnoComfort();

  // const ClientGephaProposal = useClientGephaProposal();

  const route = location.pathname;
  const langsArr = lang === "en" || lang === "ge";

  useEffect(() => {
    const lastSlashIndex = route.lastIndexOf("/");
    const splitRoute = route.substring(0, lastSlashIndex);
    const routeIsValid = routesSubroutes.hasOwnProperty(route);

    if (lang && langsArr && route !== travelRoute) {
      navigate(
        `${
          splitRoute === "" && !routeIsValid
            ? "/home"
            : routeIsValid
            ? route
            : splitRoute
        }/${lang}`
      );
    }

    if (route === travelRoute) {
      const oid = location?.search?.split("=")?.[1];
      navigate(`/${CLIENT_TRAVEL}/${oid}/${lang}`);
    }
  }, [navigate, lang]);

  useEffect(() => {
    const parts = route.split("/");
    const lastPart = parts[parts.length - 1];
    const lastPartEqualLangs = lastPart === "en" || lastPart === "ge";

    if (lastPart !== lang && lastPart !== undefined && lastPartEqualLangs) {
      dispatch(
        actions.setLanguage(
          lastPartEqualLangs ? lastPart : localStorage.getItem("lang")
        )
      );
      if (lastPartEqualLangs) localStorage.setItem("lang", lastPart);
    }
  }, []);

  return (
    <Routes>
      <Route path={"/"} element={<PageLayout />}>
        <Route index element={<Navigate replace to={HOME_PAGE_URL + lang} />} />
        <Route path={HOME_PAGE_URL + lang} element={<MainPage />} />
        <Route
          path={`${CLIENT_BLOGS}/${lang}`}
          element={<ClientBLogs />}
          // element={errorInModules ? <ErrorMessagePage /> : ""}
        />
        <Route
          path={`${CLIENT_BLOGS_DETAILS}/:id/${lang}`}
          element={<BlogDetails />}
          // element={errorInModules ? <ErrorMessagePage /> : ""}
        />
        <Route
          path={`${CLIENT_BLOGS_EVALUATIONS}/${lang}`}
          element={<ClientEvaluations />}
          // element={errorInModules ? <ErrorMessagePage /> : ""}
        />
        <Route
          path={`${CLIENT_VACANCY}/${lang}`}
          element={<ClientVacancy />}
          // element={errorInModules ? <ErrorMessagePage /> : ""}
        />
        <Route
          path={`${CLIENT_TRAVEL}/${lang}`}
          element={<ClientTravel isFromClient={true} />}
          // element={errorInModules ? <ErrorMessage /> : ""}
        />
        <Route
          path={`${CLIENT_TRAVEL}/:id/${lang}`}
          element={<ClientTravel isFromClient={true} />}
          // element={errorInModules ? <ErrorMessage /> : ""}
        />
        <Route
          path={`${CLIENT_INSURANCE_AND_MORE}/${lang}`}
          element={
            <ClientInsuranceAndMore />
            //errorInModules ? <ErrorMessage /> : ""
          }
        />
        <Route
          path={`${CLIENT_STUDENT}/${lang}`}
          element={<ClientStudent />}
          //element={errorInModules ? <ErrorMessage /> : ""}
        />
        <Route
          path={`${CLIENT_SAERTO}/*`}
          element={<ClientSaerto />}
          // element={errorInModules ? <ErrorMessage /> : ""}
        />
        <Route path={`${CLIENT_ABOUTUS}/${lang}`} element={<ClientAboutUs />} />
        <Route path={`${CLIENT_OFFICES}/${lang}`} element={<ClientOffices />} />
        <Route
          path={`${CLIENT_CHATBOT}/${lang}`}
          element={<ClientChatBot />}
          //element={errorInModules ? <ErrorMessagePage /> : ""}
        />
        {/* <Route path={`${CLIENT_OURTEAM}/${lang}`} element={<ClientOurTeam />} /> */}
        <Route
          path={`${CLIENT_MORE_ABOUT_INSURANCE}/${lang}`}
          element={<ClientMoreAboutInsurance />}
        />
        <Route
          path={`${CLIENT_LEGAL_INFO}/${lang}`}
          element={<ClientLegalInformation />}
          //element={errorInModules ? <ErrorMessagePage /> : ""}
        />
        <Route
          path={`${CLIENT_LEGAL_INFO}/:documentName/ge`}
          element={<OpenFileWithOid />}
          //element={errorInModules ? <ErrorMessagePage /> : ""}
        />
        <Route
          path={`${CLIENT_FINANCIAL_INFO}/${lang}`}
          element={<ClientFinancialInformation />}
          // element={errorInModules ? <ErrorMessagePage /> : ""}
        />
        <Route
          path={`${CLIENT_CORP_INSURANCE}/${lang}`}
          element={<ClientCorpInsurance />}
          // element={errorInModules ? <ErrorMessage /> : ""}
        />
        <Route
          path={`${CLIENT_PAYMENT_RESULT}/${lang}`}
          element={<PaymentResult />}
        />
        <Route
          path={`${CLIENT_GEPHA_PROPOSAL}/${lang}`}
          // element={
          //   errorInModules ? <ErrorMessagePage /> : <ClientGephaProposal />
          // }
          element={errorInModules ? <ErrorMessagePage /> : ""}
        />
        <Route
          path={`${TEMPORARY_PROFILE_DOCTOR}/${lang}`}
          element={<ErrorMessage />}
        />
        <Route
          path={`${CLIENT_INSIDE_TRAVEL}/${lang}`}
          // element={
          //   errorInModules ? <ErrorMessagePage /> : <ClientGephaProposal />
          // }
          element={<ClientInsideTravel />}
        />
        <Route
          path={`${CLIENT_OFFERS}/*`}
          // element={
          //   errorInModules ? <ErrorMessagePage /> : <ClientGephaProposal />
          // }
          element={<ClientOffers />}
        />
        <Route path={`${CLIENT_UNO}/*`} element={<ClientUno />} />
        <Route path={`${CLIENT_CAR}/*`} element={<ClientCar />} />
        <Route path={`${CLIENT_AUTO_CAR}/*`} element={<ClientCarAuto />} />
        <Route path={`${CLIENT_UNO_ACTIVE}/*`} element={<ClientUnoActive />} />
        <Route path={`${CLIENT_UNO_SELECT}/*`} element={<ClientUnoSelect />} />
        <Route
          path={`${CLIENT_UNO_COMFORT}/*`}
          element={<ClientUnoComfort />}
        />
        {/* <Routes
          path={`${TEMPORARY_APPEALS}/${lang}`}
          element={<ErrorMessage />}
        />
        <Route path={`${TEMPORARY_REIMB}/${lang}`} element={<ErrorMessage />} /> */}
        <Route path={`${NO_SMS}/${lang}`} element={<NoSms />} />
        <Route
          path={`${REQUEST_CALL}/:productId/${lang}`}
          element={<RequestCall />}
        />
        <Route path={`${PAY_REDIRECT}/${lang}`} element={<PayRedirect />} />
        <Route path={`${TOOTSIE}/${lang}`} element={<Tootsie />} />
        <Route
          path={`${PRIVACY_POLICY}/${lang}`}
          element={<PrivacyPolicies />}
        />
        <Route
          path={`${PRIVACY_STATEMENT}/${lang}`}
          element={<PrivacyStatement />}
        />
        <Route path="*" element={<PageNotFound />} />
      </Route>
    </Routes>
  );
};

export default Layout;
